import { LOGO_DARK, LOGO_WHITE, ICON_DARK, ICON_WHITE } from "@/lib/api";
import { Link } from "react-router-dom";

export function Logo({ className = "", to = "/", size = "h-14 sm:h-16", tone = "light" }) {
  const wordmark = tone === "dark" ? LOGO_WHITE : LOGO_DARK;
  const icon = tone === "dark" ? ICON_WHITE : ICON_DARK;
  return (
    <Link to={to} className={`flex items-center ${className}`} data-testid="logo-link">
      <img src={icon} alt="" className={`${size} w-auto object-contain`} />
      <img src={wordmark} alt="Climateasy" className={`${size} -ml-0.5 w-auto object-contain`} />
      <span className="sr-only">Climateasy</span>
    </Link>
  );
}
